import { RequestFailure } from '@owl-nest/api-client'
import { Order } from '@owl-nest/api-client/latest'

import { OrderAction, TYPE } from './actions'
import { Status } from '../../status'

export type OrderState = {
  failure?: RequestFailure
  orders: Order[]
  status: {
    creation: Status
    get: Status
    renew: Status
  }
}

const initialState: OrderState = {
  failure: undefined,
  orders: [],
  status: {
    creation: Status.PRISTINE,
    renew: Status.PRISTINE,
    get: Status.PRISTINE,
  },
}

export function reducer(state: OrderState = initialState, action: OrderAction): OrderState {
  switch (action.type) {
    case TYPE.CREATE_REQUEST: {
      return {
        ...state,
        failure: undefined,
        status: {
          ...state.status,
          creation: Status.PENDING,
        },
      }
    }

    case TYPE.CREATE_SUCCESS: {
      return {
        ...state,
        orders: [...state.orders, action.success],
        status: {
          ...state.status,
          creation: Status.SUCCESS,
        },
      }
    }

    case TYPE.CREATE_FAILURE: {
      return {
        ...state,
        failure: action.failure,
        status: {
          ...state.status,
          creation: Status.FAILURE,
        },
      }
    }

    case TYPE.GET_FAILURE: {
      return {
        ...state,
        failure: action.error,
        status: {
          ...state.status,
          get: Status.FAILURE,
        },
      }
    }

    case TYPE.GET_REQUEST: {
      return {
        ...state,
        failure: undefined,
        status: {
          ...state.status,
          get: Status.PENDING,
        },
      }
    }

    case TYPE.GET_SUCCESS: {
      const orders = state.orders.filter(order => order.id != action.success.id)
      return {
        ...state,
        orders: [...orders, action.success],
        status: {
          ...state.status,
          get: Status.SUCCESS,
        },
      }
    }

    case TYPE.RESET: {
      return initialState
    }

    case TYPE.RENEW_FAILURE: {
      return {
        ...state,
        failure: action.failure,
        status: {
          ...state.status,
          renew: Status.FAILURE,
        },
      }
    }

    case TYPE.RENEW_REQUEST: {
      return {
        ...state,
        status: {
          ...state.status,
          renew: Status.PENDING,
        },
      }
    }

    case TYPE.RENEW_SUCCESS: {
      const orders = state.orders.filter(order => order.id !== action.success.id)
      return {
        ...state,
        orders: [...orders, action.success],
        status: {
          ...state.status,
          renew: Status.SUCCESS,
        },
      }
    }

    default:
      return state
  }
}
